var map = {
	"./Azure SQL Database.svg": 891,
	"./Bootstrap.svg": 748,
	"./CSS.png": 279,
	"./Git.svg": 908,
	"./Github.svg": 323,
	"./HTML.png": 637,
	"./Javascript.svg": 744,
	"./LeetCode_logo_black.svg": 589,
	"./React.png": 736,
	"./Redux.svg": 67,
	"./Tailwind.png": 515,
	"./Vercel.svg": 483,
	"./java.svg": 995,
	"./leetcode.svg": 464,
	"./material-ui.svg": 333,
	"./postman.svg": 977,
	"./spring-boot.svg": 807,
	"./sql-icon.svg": 595,
	"./typescript.svg": 25
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 805;